<template>
<div v-bind:class="{'ui loading form': (loaded==1)}">
  <form class="ui form segment">
    <app-header v-if="showMenu" ></app-header>

  
   

  <div class="ui attached segment">

  <div class="three fields">
        <div class="field">
            <label>Guid</label>
            <input placeholder="Guid"  style="width:450px" name="_guid" type="text"  ref="ipGuid">
        </div>
         <div class="field">
            <label>Doc Name</label>
            <input placeholder="Doc Name"  style="width:450px" name="_docName" type="text"  ref="ipDocName">
        </div>
         <div class="field">
            <label>PO Number</label>
            <input placeholder="PO Number"  style="width:450px" name="_poNumber" type="text"  ref="ipPOnumber">
        </div>
  
  </div>

    <div class="three fields">
        <div class="field">
            <label>Vendor Code</label>
            <input placeholder="Vendor Code"  style="width:450px" name="_vendorCode" type="text"  ref="ipVendorCode">
        </div>
         <div class="field">
            <label>Buyer Code</label>
            <input placeholder="Buyer Code"  style="width:450px" name="_buyerCode" type="text"  ref="ipBuyerCode">
        </div>
         <div class="field">
            <label>Ship Code</label>
            <input placeholder="Ship Code"  style="width:450px" name="_shipCode" type="text"  ref="ipShipCode">
        </div>
  
  </div>

    <div class="three fields">
        <div class="field">
            <label>Buyer Name</label>
            <input placeholder="Buyer Name"  style="width:450px" name="_buyerName" type="text"  ref="ipBuyerName">
        </div>
         <div class="field">
            <label>Vendor Name</label>
            <input placeholder="Vendor Name"  style="width:450px" name="_vendorName" type="text"  ref="ipVendorName">
        </div>
         <div class="field">
            <label>Date Received</label>
            <input  style="width:450px" name="_dateReceived" type="text"  ref="ipDate">
        </div>
  
  </div>

  

 



 <div class="ui primary submit button"   @click="updateTrackingDetails()" >Update</div>
          <div class="ui button"  @click="closeWindow()">Close Current Window</div>


</div>

    </form>
  </div>



 
</template>

<script>
import axios from "axios";
import Header from '@/components/Header.vue';
import Vue from 'vue'


export default {
  components: {
    appHeader: Header
 
  },
  data () {
    return {
      loaded : "1",
      httpOptions: {
      headers: {
      authorization: ""
      }
    },
      loading: '',
      showMenu :false,
      headerData : [],
      document_id:'' ,
      doctype_id :'',
      status_id :'',
     community_id :'',
    
      input: {
        refreshtoken : ""
      }   ,
      diffMins : 0,
      refreshToken_Event_Fired : 0 ,
    moreParams: { _filter : '' , _buyer_code : '',_vendor_code : '',_loc_code : '', _corc_code : ''},
    
   }
 },
 methods: {
   bindTrackingDetails(){
         if(localStorage.getItem('id_token')){
         this.loaded = 1;
         axios({ method: "GET", "url": Vue.prototype.$hostname + "gettrackinglist/" + CryptoJS.AES.decrypt( this.$route.query.docType, 'corcentric').toString(CryptoJS.enc.Latin1) + "/" + 
         CryptoJS.AES.decrypt( this.$route.query.docId, 'corcentric').toString(CryptoJS.enc.Latin1) +  "/N" 
         , 
              "headers": 
               { 
                  "content-type": "application/json",
                  "authorization": "bearer " + localStorage.getItem('id_token') 
                } }).then
                (
                    result => {
                    this.headerData = result.data;
                    
                    console.log(this.headerData);
                       this.document_id = this.headerData[0].document_id;
                       this.doctype_id = this.headerData[0].doc_type_id;
                       this.status_id = this.headerData[0].status_id;
                       this.community_id =  this.headerData[0].community_id;

                       this.$refs.ipGuid.value =  this.headerData[0]. guid;
                       this.$refs.ipDocName.value = this.headerData[0].document_name;
                       this.$refs.ipPOnumber.value =  this.headerData[0].po_number;
                       this.$refs.ipVendorCode.value = this.headerData[0].vendor_code;

                       this.$refs.ipBuyerCode.value = this.headerData[0].buyer_code;
                       this.$refs.ipShipCode.value =  this.headerData[0].ship_code;
                       this.$refs.ipBuyerName.value = this.headerData[0].buyer_name;
                       this.$refs.ipVendorName.value =  this.headerData[0].vendor_name;
                       this.$refs.ipDate.value = this.headerData[0].date_received;
               }, 
                error => {
                    console.error(error);
                    this.sessionExpired(error.response.status);
                });
              this.loaded = 2;
        }       
    },
    
   
sessionExpired(errorStatus){
      if (errorStatus === 403 && this.tokenExpired === 0 ) {
        this.tokenExpired = 1;
        alert('Sesssion expired.Please login again!!');
        this.$router.push({name: 'Login'});
    }
   },


   closeWindow(){
    window.close();
  },

  updateTrackingDetails(){
     
        swal({
        title: "",
        text: "Are you sure, to update tracking Details?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Update it!",
        closeOnConfirm: true
        },() => {
         
          axios({ method: "POST", "url": Vue.prototype.$hostname +  "updatetracking", 
            "data": {
            guid : this.$refs.ipGuid.value.trim() ,
            document_id : this.document_id,
            doctype_id : this.doctype_id,
            document_name  : this.$refs.ipDocName.value.trim(),
            po_number : this.$refs.ipPOnumber.value.trim(),
            seller_code :  this.$refs.ipVendorCode.value.trim(),
            agency_code :  this.$refs.ipBuyerCode.value.trim(),
            shop_code :  this.$refs.ipShipCode.value.trim(),
            community_id : this.community_id ,

            buyer_name :  this.$refs.ipBuyerName.value.trim(),
            vendor_name :  this.$refs.ipVendorName.value.trim(),
            status_id :  this.status_id
         }, 
            "headers": 
            { 
              "content-type": "application/json" ,
              "authorization": "bearer " + localStorage.getItem('id_token') 
            }  }).then
            (
              result => {
                sweetAlert('Data has been updated successfully!', '', 'success')
              }, 
            error => {
            console.error(error);
            this.sessionExpired(error.response.status);
            sweetAlert('Something\'s Wrong!', error, 'error')
            });
      
        
      })
      
    },

   checkTokenExpired(){
    if(this.refreshToken_Event_Fired == 0){
    this.getTokenExpiryTime();/* Get Token Expiry time  in Minutes */
    if(this.diffMins <= Vue.prototype.$session_Expire_in && this.diffMins > 0  ){ /* If Token Expiring in (expires_in from service) Mins,then get refereh token */
      this.refreshToken_Event_Fired = 1 ;
      this.getRefreshToken();
      this.refreshToken_Event_Fired = 0;
    }
     }
    },
    async getRefreshToken() {
    this.input['refreshtoken'] = localStorage.getItem('refresh_token')
    await axios({ method: "POST", "url": Vue.prototype.$appName + "token/refreshtoken", 
      "data": this.input, 
      "headers": { "Access-Control-Allow-Origin" : "*",
      "content-type": "application/json" } }).then
      (
          result => {
          this.response = result.data;
          localStorage.setItem('id_token', result.data.access_token);
          localStorage.setItem('refresh_token', result.data.refresh_token);

          var now = new Date();
          now.setMinutes(now.getMinutes() + Math.floor(result.data.expires_in / 60)  ); // timestamp
          now = new Date(now); // Date object
          localStorage.setItem('expiry_date', now);
         }, 
      error => {
        this.refreshToken_Event_Fired = 0;
        console.error(error);
      });

    },
    getTokenExpiryTime() {
      var expiry_date =  new Date(localStorage.getItem('expiry_date'));
      var today = new Date();
      var diffMs = (expiry_date - today); // milliseconds between now & logintime
      this.diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
       
    },
    preg_quote ( str ) {
       return (str+'').replace(/([\\\.\+\*\?\[\^\]\$\(\)\{\}\=\!\<\>\|\:])/g, "\\$1");
    },
    highlight (needle, haystack) {
      return haystack.replace(
        new RegExp('(' + this.preg_quote(needle) + ')', 'ig'),
        '<span class="highlight">$1</span>'
        )
    },
    
    
    
    showLoader () {
      this.loading = 'loading'
    },
    hideLoader () {
      this.loading = ''
    },
    
    


  },
 created() {
     if(!localStorage.getItem('id_token') ){
       this.$router.push({name: 'Login'});
     }else{
     this.checkTokenExpired();
            this.bindTrackingDetails();

 
     }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/integration-tracking/UpdateTracking.vue